var _path, _path2, _path3, _path4, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "uk_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#uk_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v12h16V0H0z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "uk_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v12h16V0H0z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#uk_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uk_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#uk_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.782 11.143l3.521 1.489L16.08 1.619l1.858-2.213-3.765-.498-5.85 4.746-4.707 3.198-5.397 4.29z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.3 12.186l1.794.864L17.27-.8H14.75l-16.05 12.986z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.782 11.143l-3.521 1.489L-.08 1.619-1.938-.594l3.765-.498 5.85 4.746 4.707 3.198 5.397 4.29z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.662 11.891l-1.794.865-7.143-5.93-2.118-.663-8.723-6.75H.403l8.717 6.59 2.316.795 6.226 5.093z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "uk_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.889-1H6.11v5H-.986v4H6.11v5h3.778V8h7.125V4H9.889v-5z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.889-1H6.11v5H-.986v4H6.11v5h3.778V8h7.125V4H9.889v-5z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.111-1v-1h-1v1h1zm3.778 0h1v-1h-1v1zM6.11 4v1h1V4h-1zM-.986 4V3h-1v1h1zm0 4h-1v1h1V8zM6.11 8h1V7h-1v1zm0 5h-1v1h1v-1zm3.778 0v1h1v-1h-1zm0-5V7h-1v1h1zm7.125 0v1h1V8h-1zm0-4h1V3h-1v1zM9.889 4h-1v1h1V4zM6.11 0h3.778v-2H6.11v2zm1 4v-5h-2v5h2zM-.986 5H6.11V3H-.986v2zm1 3V4h-2v4h2zM6.11 7H-.986v2H6.11V7zm1 6V8h-2v5h2zm2.778-1H6.11v2h3.778v-2zm-1-4v5h2V8h-2zm8.125-1H9.889v2h7.125V7zm-1-3v4h2V4h-2zM9.889 5h7.125V3H9.889v2zm-1-6v5h2v-5h-2z",
    fill: "#fff",
    mask: "url(#uk_svg__d)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 11,
    rx: 0.5,
    stroke: "#000",
    strokeOpacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }));
}

export default __webpack_public_path__ + "static/media/uk.76da6987.svg";
export { SvgUk as ReactComponent };